import { ValueGetterFunc } from "ag-grid-community";
import { OffHoursSchedule } from "@/services/cloudchipr.api";

export const offHoursAccountValueGetter: ValueGetterFunc<OffHoursSchedule> = ({
  data,
}) => {
  if (!data) {
    return "-";
  }

  return data.accounts
    .filter(({ status }) => status === "connected" || status === undefined)
    .map((account) => account.provider_account_name)
    .join(", ");
};
